import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRedirect from 'react-router/lib/IndexRedirect';
import IndexRoute from 'react-router/lib/IndexRoute';
import BrandApp from './brandApp';
import * as hooks from '../auth/routerHooks';
import ReportRoutes from '../main/reports/routes';
import EngagementRoutes from '../engagement/routes';
import { CampaignBuilderRoutes } from '../../modules/shared/engage/campaign-builder/routes';
import DiscountsRoutes from '../main/discounts/routes';
import CustomerRoutes from '../main/customers/routes';
import SettingsRoutes from '../main/settings/routes';
import ServiceCategoriesRoutes from '../main/services/categories/routes';
import ListServicesProvider from '../main/services/containers/listServicesProvider';
import EditServiceProvider from '../main/services/containers/editServiceProvider';
import { BrandProductRoutes } from '../products/routes';
import MembershipsRoutes from '../memberships/routes';
import BarbersRoutes from '../main/barbers/routes';
import StaffManagementRoutes from '../main/staffManagement/routes';

export default store => (
  <Route path="/brand" component={BrandApp} onEnter={hooks.requireBrand(store)}>
    <IndexRedirect to="reports" />
    {ReportRoutes.BrandRoutes(store)}
    {EngagementRoutes(store)}
    {CampaignBuilderRoutes(store)}
    {DiscountsRoutes.BrandRoutes(store)}
    {CustomerRoutes.BrandRoutes(store)}
    {SettingsRoutes.BrandRoutes(store)}
    {BrandProductRoutes(store)}
    {MembershipsRoutes.BrandRoutes(store)}
    {BarbersRoutes.BrandRoutes(store)}
    {StaffManagementRoutes(store)}
    <Route path="services">
      <IndexRoute component={ListServicesProvider} />
      <Route path="categories">
        {ServiceCategoriesRoutes()}
      </Route>
      <Route
        path="add"
        name="services.add"
        component={EditServiceProvider}
      />
      <Route
        path=":serviceId"
        name="services.details"
        component={EditServiceProvider}
      />
      <Route
        path=":serviceId/assign"
        name="services.assign"
        component={EditServiceProvider}
      />
    </Route>
  </Route>
);
